import React from 'react';
import '../assest/Loader.css'; 

const Loader = ({ size = 40, color = '#c0c0c0', fullscreen = true}) => {
  const spinnerStyle = {
    width: `${size}px`,
    height: `${size}px`,
    position: 'relative',
    animation: 'spinY 2s linear infinite',
    transformStyle: 'preserve-3d'
  };

  const containerStyle = {
    height: fullscreen ? '100vh' : 'auto',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  };

  const ringStyle = {
    position: 'absolute',
    bottom: '0',
    left: '50%',
    transform: 'translateX(-50%)',
    width: `${size * 0.8}px`,
    height: `${size * 0.8}px`,
    border: `${size * 0.08}px solid ${color}`,
    borderRadius: '50%',
    background: 'transparent',
    boxShadow: `
      0 0 10px ${color}40,
      inset 0 0 5px ${color}20,
      0 4px 15px rgba(0,0,0,0.3)
    `
  };

  const diamondStyle = {
    position: 'absolute',
    top: '0',
    left: '50%',
    transform: 'translateX(-50%)',
    width: `${size * 0.35}px`,
    height: `${size * 0.35}px`,
    background: 'linear-gradient(135deg, #ffffff, #e3f2fd, #bbdefb, #90caf9, #ffffff)',
    clipPath: 'polygon(50% 0%, 20% 35%, 35% 100%, 65% 100%, 80% 35%)',
    filter: 'drop-shadow(0 2px 8px rgba(0,0,0,0.3))',
    zIndex: 10,
    animation: 'sparkle 1.5s ease-in-out infinite alternate'
  };

  const twinkleStyle = {
    position: 'absolute',
    top: `${size * 0.08}px`,
    left: '50%',
    transform: 'translateX(-50%)',
    width: `${size * 0.15}px`,
    height: `${size * 0.15}px`,
    background: 'radial-gradient(circle, #ffffff, transparent)',
    borderRadius: '50%',
    zIndex: 11,
    animation: 'twinkle 1s ease-in-out infinite alternate'
  };

  return (
    <div className='loader-container' style={containerStyle}>
      <style>
        {`
          @keyframes spinY {
            0% { transform: rotateY(0deg); }
            100% { transform: rotateY(360deg); }
          }
          
          @keyframes sparkle {
            0% { 
              opacity: 0.9; 
              transform: translateX(-50%) scale(1);
              filter: drop-shadow(0 2px 8px rgba(0,0,0,0.3)) brightness(1);
            }
            100% { 
              opacity: 1; 
              transform: translateX(-50%) scale(1.05);
              filter: drop-shadow(0 4px 12px rgba(0,0,0,0.4)) brightness(1.2);
            }
          }
          
          @keyframes twinkle {
            0% { 
              opacity: 0.6; 
              transform: translateX(-50%) scale(0.8);
            }
            100% { 
              opacity: 1; 
              transform: translateX(-50%) scale(1.3);
            }
          }
        `}
      </style>
      
      <div style={spinnerStyle}>
        {/* Yüzük halkası */}
        <div style={ringStyle} />
        
        {/* Pırlanta taşı */}
        <div style={diamondStyle} />
        
        {/* Pırlanta parıltısı */}
        <div style={twinkleStyle} />
        
        {/* Yüzük detayları */}
        <div style={{
          position: 'absolute',
          bottom: `${size * 0.7}px`,
          left: '50%',
          transform: 'translateX(-50%)',
          width: `${size * 0.15}px`,
          height: `${size * 0.1}px`,
          background: `linear-gradient(90deg, ${color}, ${color}cc, ${color})`,
          borderRadius: '4px',
          boxShadow: '0 1px 3px rgba(0,0,0,0.3)'
        }} />
      </div>
    </div>
  );
};
export default Loader;

